"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import ErrorBoundary from "../errorboundary/ErrorBoundary.js";
import dynamic from 'next/dynamic.js';
import styles from "./Instagram.module.css";
//#endregion
//#region [Component]
const DynamicInstagramEmbed = dynamic(() => import('react-social-media-embed').then((mod) => mod.InstagramEmbed), { ssr: false });
export default function Instagram({ value }) {
    if (!value?.instagramPostId) {
        return null;
    }
    return _jsx("div", { className: styles.instagramContainer, children: _jsx(ErrorBoundary, { children: _jsx(DynamicInstagramEmbed, { url: `https://www.instagram.com/p/${value.instagramPostId}/`, width: "100%" }) }) });
}
